import Clipboard from 'clipboard';

import styled from 'vue-styled-components';
import COLORS from '@design/colors.js';
import { applyHoverAndPress } from '@styles/common.styled';

import {
    FLEX_COLUMN_DIV,
    GRAY_100_DIV,
    FLEX_VERTICAL_CENTER_DIV,
} from '@styles/common.styled.component';

export default {
    name: 'CopyLink',
    mounted() {
        const clipboard = new Clipboard('.copy-target', {
            text: R.always(this.link),
        });
        clipboard.on(
            'success',
            () => this.toastEnabled && this.toast(this.$t('COMMON.copied'))
        );

        this.getBeforeDestroy$().subscribe(() => clipboard.destroy());
    },
    props: {
        label: {
            type: String,
            default: '',
        },
        link: {
            type: String,
            default: '',
        },
    },
    render() {
        const { label, link } = this;
        return (
            <CopyWrapper>
                {label && <CopyText domPropsInnerHTML={label}></CopyText>}
                <CopyArea>
                    <CopyBox class="copy-target adriel-ellipsis">
                        {link}
                    </CopyBox>
                    <CopyBtn class="copy-target">
                        {this.$t('CONNECTION.copy_link')}
                    </CopyBtn>
                </CopyArea>
            </CopyWrapper>
        );
    },
};

const CopyWrapper = FLEX_COLUMN_DIV;

const CopyText = styled(GRAY_100_DIV)`
    font-size: 16px;
    white-space: pre-line;
`;

const CopyArea = styled.div`
    display: flex;
    justify-content: space-between;
    min-height: 44px;
    margin-top: 24px;
    @media screen and (max-width: 767px) {
        flex-wrap: wrap;
        height: auto;
    }
`;

const CopyBox = styled(FLEX_VERTICAL_CENTER_DIV)`
    flex: 1;
    justify-content: flex-start;
    border-radius: 2px;
    background-color: ${COLORS['gray-10']};
    padding: 12px 16px;
    font-size: 14px;
    color: ${COLORS['gray-100']};
    white-space: pre-line;
    word-break: break-word;
`;

const CopyBtn = styled.button`
    border-radius: 2px;
    border: solid 1px ${COLORS['gray-30']};
    ${applyHoverAndPress('white', 'background-color')}
    margin-left: 8px;
    min-width: 120px;
    @media screen and (max-width: 767px) {
        width: 100%;
        margin-left: 0px;
        margin-top: 12px;
        height: 44px;
    }
`;
